import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { CollectionsEntity } from "./collections.entity";
import { CollectionsService } from "./collections.service";
import { CollectionsController } from "./collections.controller";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { SaleOrderService } from "@gtpl/shared-services/sale-management";
import { RodtepEntity } from "./rodtep.entity";
import { PayableEntity } from "./payables.entity";

@Module({
    imports:[
        TypeOrmModule.forFeature([CollectionsEntity,RodtepEntity,PayableEntity])
    ],
    controllers:[CollectionsController],
    providers:[ApplicationExceptionHandler,CollectionsService,SaleOrderService]
})
export class CollectionsModule{}